<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 4"
    class="h-1 w-full"
    preserveAspectRatio="none"
  >
    <rect x="0" y="0" width="100" height="4" fill="currentColor" opacity="0.25" rx="2" />
    <rect y="0" width="35" height="4" fill="currentColor" opacity="0.75" rx="2">
      <animate
        attributeName="x"
        from="-35"
        to="100"
        dur="1.2s"
        repeatCount="indefinite"
        calcMode="spline"
        keyTimes="0;1"
        keySplines="0.4 0 0.6 1"
      />
    </rect>
  </svg>
</template>
